// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InterviewRecruitment_wrapper__2l8ul","dismiss-button":"InterviewRecruitment_dismiss-button___FyG_"};